const video = document.getElementById('bgVideo');
const btn = document.getElementById('playPauseBtn');

if (btn) {
  btn.addEventListener('click', () => {
    if (video.paused) {
      video.play();
      btn.innerHTML = 'Pause'; // Or update to a pause icon
      btn.classList.remove('play');
      btn.classList.add('pause');
    } else {
      video.pause();
      btn.innerHTML = 'Play'; // Or update to a play icon
      btn.classList.remove('pause');
      btn.classList.add('play');
    }
  });

  // preload the play button
  function preloadSVG (url) {
    const img = new Image();
    img.src = url;
  }

  // Usage
  preloadSVG('/img/play-btn.svg');
}